// state
import { INewSimulationState, getInitialNewSimulationState } from "@store/state/NewSimulation";

// actions
import { INewSimulationAction, NewSimulationActionType } from "@store/actions/NewSimulation";

// helpers
import { createDeepCopy } from "@utils/index";

// Reducer to handle simulation state and actions
export const newSimulationReducer = (
    state: INewSimulationState = getInitialNewSimulationState(),
    action: INewSimulationAction,
): INewSimulationState => {
    switch (action.type) {
        case NewSimulationActionType.INITIALIZE_NEW_SIMULATION_STATE:
        case NewSimulationActionType.UPDATE_NEW_SIMULATION_STATE:
        case NewSimulationActionType.SET_READ_ONLY:
        case NewSimulationActionType.SET_SIMULATION_ID:
        case NewSimulationActionType.SET_SCENARIO_LIST:
        case NewSimulationActionType.SET_SIMULATION_DATA:
        case NewSimulationActionType.SET_SELECTED_SCENARIO:
        case NewSimulationActionType.SET_SIMULATION_STEPPERS:
        case NewSimulationActionType.SET_ACTIVE_SIMULATION_STEPPER:
        case NewSimulationActionType.SET_SIMULATION_INPUTS:
        case NewSimulationActionType.SET_SELECTED_COST_POOL_LIST:
        case NewSimulationActionType.SET_IS_SYSTEM_DEFINITION_AND_MAPPING_SELECTED:
            // createDeepCopy is used to ensure immutability - creates a completely new object
            // with all nested properties copied, preventing any accidental mutations of the original state
            return createDeepCopy({
                ...state,
                ...action.payload,
            });
        default:
            return state;
    }
};
